'use strict';

$(window).ready(() => {
    /*
        Default overrides
    */

    if(!localStorage.getItem('nav-theme')) {
        localStorage.setItem('nav-theme', 'light');
    }

    if(!localStorage.getItem('raul-left-navigation-expanded')) {
        localStorage.setItem('raul-left-navigation-expanded', '1');
    }

    /*
        Missing functionality from raul.js - Found on demo page (https://cdn.realpage.com/raul/v2.0.3/demo/index.html#)
    */

    if(localStorage.getItem('nav-theme') === 'dark') {
        $('.leftNavToggle i').removeClass('fa-toggle-off');
        $('.leftNavToggle i').addClass('fa-toggle-on');
    }

    $('.leftNavToggle i').on('click', function() {
        if($(this).hasClass('fa-toggle-off')) {
            $(this).removeClass('fa-toggle-off');
            $(this).addClass('fa-toggle-on');
            RAUL.leftnav.$leftnav.removeClass('raul-left-navigation-light');
            RAUL.leftnav.$leftnav.addClass('raul-left-navigation-dark');
            localStorage.setItem('nav-theme', 'dark');
        } else {
            $(this).removeClass('fa-toggle-on');
            $(this).addClass('fa-toggle-off');
            RAUL.leftnav.$leftnav.removeClass('raul-left-navigation-dark');
            RAUL.leftnav.$leftnav.addClass('raul-left-navigation-light');
            localStorage.setItem('nav-theme', 'light');
        }
    });

    /*
        RAUL uses cookies to keep track of nav expansion state, but it's buggy with complicated cookie strings...
    */

    let body = $(document.body);
    if(localStorage.getItem('raul-left-navigation-expanded') === '0') {
        if(window.RAUL) { RAUL.header.changeNavState(); }
    }

    $('#raul-header-menu-button').on('click', () => {
        lead2lease.utilities.nextTick(() => {
            localStorage.setItem('raul-left-navigation-expanded', body.hasClass('raul-left-navigation-expanded') ? '1' : '0');
        });
    });

    /*
        Handle header breadcrumbs based on navigation menu or current page title
    */

    let navigationLookup = (function buildNavigationLookup(currentNode, parent) {
        let ret = {};

        currentNode.each((index, currentElement) => {
            currentElement = $(currentElement);

            let item = $(currentElement.children('.raul-left-navigation-item, .raul-left-navigation-subitem').get(0)),
                link = item.is('a') ? item : item.find('a'),
                href = link.attr('href');

            let hasSubitems = item.hasClass('has-subitems'),
                subitems = hasSubitems ? currentElement.find('.raul-left-navigation-subitems') : null,
                title = item.find('.raul-left-navigation-item-display').text();

            let entry = ret[href ? href.toLowerCase() : `#${title}`] = {
                title: title,
                children: null,
                item,
                subitems,
                link,
                href,
                parent
            };

            if(hasSubitems) {
                entry.children = buildNavigationLookup(subitems.children('li'), entry);
            }
        });

        return ret;
    })($('#raul-left-navigation .raul-left-navigation-items').children('li'), null);

    function findNavigationEntry(url, currentNode) {
        let ret = null;

        url = url.toLowerCase();

        for(let i in currentNode) {
            if(url.indexOf(i) === 0) {
                ret = currentNode[i];
                break;
            }
            else if(currentNode[i].children && (ret = findNavigationEntry(url, currentNode[i].children))) {
                break;
            }
        }

        return ret;
    }

    function breadcrumbBindClick(target, source, url) {
        return target.attr('href', url).on('click', event => { source.trigger('click'); });
    }

    function updateBreadcrumbs(currentNode) {
        let navigationStack = [];

        if(currentNode) {
            while(currentNode) {
                navigationStack.push({
                    title: currentNode.title,
                    link: currentNode.link,
                    url: currentNode.href
                });
                currentNode = currentNode.parent;
            }
        }
        else {
            navigationStack.push({
                title: document.title,
                url: window.location.pathname
            });
        }

        navigationStack.push({
            title: 'Lead2Lease',
            url: null,
            link: null
        });

        let dropdownBreadcrumbs = $('#raul-page-header-breadcrumbs-dropdown').empty(),
            breadcrumbs = $('#raul-page-header-breadcrumbs');

        $('#raul-page-header-breadcrumbs-back').nextAll().remove();

        for(let i = navigationStack.length - 1; i >= 0; i--) {
            if(i !== 0) {
                breadcrumbs.append(breadcrumbBindClick($('<a class="raul-page-header-breadcrumb d-none d-md-inline-block"></a>'), navigationStack[i].link, navigationStack[i].url)
                    .text(navigationStack[i].title));

                breadcrumbs.append($('<span class="d-none d-md-inline-block p-l-5 p-r-5"> / </span>'));

                dropdownBreadcrumbs.append(breadcrumbBindClick($('<a class="raul-page-header-breadcrumbs-dropdown-breadcrumb"></a>'), navigationStack[i].link, navigationStack[i].url)
                    .text(navigationStack[i].title));
            }
            else {
                breadcrumbs.append(breadcrumbBindClick($('<a class="raul-page-header-breadcrumb"></a>'), navigationStack[i].link, navigationStack[i].url)
                    .append($('<strong></strong>')
                        .text(navigationStack[i].title)));
            }
        }

        $('#raul-page-header-page').text(navigationStack[0].title);
    };

    /*
        Handle navigation menu active states
    */

    function updateNavigationMenu(currentNode) {
        let ignoreElements = $();

        let firstLevel = true;
        while(currentNode) {
            if(currentNode.item.hasClass('active')) {
                currentNode.item.removeClass('active');
            }
            else {
                currentNode.item.addClass('active');
            }

            $.merge(ignoreElements, currentNode.item);

            if(currentNode.subitems) {
                let arrow = currentNode.item.find('.raul-left-navigation-item-arrow');
                if(firstLevel && currentNode.subitems.hasClass('subitems-open')) {
                    currentNode.subitems.removeClass('subitems-open');
                    arrow.removeClass('fa-angle-up').addClass('fa-angle-down');
                }
                else {
                    currentNode.subitems.addClass('subitems-open');
                    arrow.removeClass('fa-angle-down').addClass('fa-angle-up');
                }

                $.merge(ignoreElements, currentNode.subitems);
                $.merge(ignoreElements, arrow);
            }

            currentNode = currentNode.parent;
            firstLevel = false;
        }

        $('#raul-left-navigation .raul-left-navigation-item.active, #raul-left-navigation .raul-left-navigation-subitem.active').not(ignoreElements).removeClass('active');
        $('#raul-left-navigation .raul-left-navigation-subitems.subitems-open').not(ignoreElements).removeClass('subitems-open');
        $('#raul-left-navigation .raul-left-navigation-item-arrow.fa-angle-up').not(ignoreElements).removeClass('fa-angle-up').addClass('fa-angle-down');
    }

    let lastNode = null;
    function updateNavigation(url) {
        let currentNode = findNavigationEntry(url, navigationLookup);

        if(lastNode == null || lastNode !== currentNode) {
            updateBreadcrumbs(currentNode);

            // Need this to schedule the menu update to happen after the navigation click has been handled...
            lead2lease.utilities.nextTick(() => {
                updateNavigationMenu(currentNode);
            });
        }

        lastNode = currentNode;
    }

    lead2lease.ui.UIRouter.on('updated', url => { updateNavigation(url); });

    updateNavigation(`${location.pathname}${location.search}`);

    /*
        Application switcher context population
    */

    if(window.RAUL) {
        RAUL.header.$switcher.data = [ {
            productId: 9,
            titleUniqueId: '702afbcb-0bdb-4360-b120-c852fb593512',
            titleID: 'Websites & Syndication',
            productUrl: 'https://mc.realpage.com/',
            isNewTab: true,
            productName: 'Websites & Syndication',
            productTypeId: 0,
            productDescription: 'Provides access to Marketing Center which provides tools to manage your community website and other related marketing content.',
            isAllowFavorite: true,
            isFavorite: true,
            hasAccess: true,
            familyId: 300,
            family: 'Lease Management',
            solutionId: 303,
            solution: 'Websites and Syndication',
            subsolution: null,
            isResource: false,
            learnMore: 'https://www.realpage.com/apartment-marketing/website-design/',
            productStatus: 8
        } ];
    }
});